import { useLocation, useNavigate } from 'react-router';
import Icon from './Icon';
import { useAppPath } from '../lib/AppContext';

// A page's title with a back button (to the previous screen, or `fallback` when opened directly).
export default function PageHeader({ title, fallback = '/settings', children }) {
  const path = useAppPath();
  const navigate = useNavigate();
  const location = useLocation();
  const back = () => (location.key !== 'default' ? navigate(-1) : navigate(path(fallback)));
  return (
    <div className="pt-safe flex items-center justify-between gap-2 pt-4">
      <div className="flex min-w-0 items-center gap-1">
        <button type="button" className="btn btn-circle btn-ghost -ml-2 size-11 shrink-0" aria-label="Quay lại" onClick={back}>
          <Icon name="chevronLeft" className="size-6" />
        </button>
        <h1 className="truncate text-[22px] font-bold">{title}</h1>
      </div>
      {children && <div className="flex shrink-0 items-center gap-2">{children}</div>}
    </div>
  );
}
